<script>
  // Select items from static options array
  import { map, find, assign, cloneDeep, each, isEmpty } from 'lodash'

  export default {
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      options: {
        type: Array,
        default: () => [],
      },
      preselected: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        selected: (this.preselected && isEmpty(this.value)) ? this.options.map(o => o.value) : this.value,
        terms: this.options,
      }
    },
    watch: {
      value (selected) {
        this.selected = selected
      },
      selected (value) {
        this.$emit('input', value)
      },
      options (newOptions) {
        // Keep old options disable
        this.terms = map(cloneDeep(this.terms), (term) => {
          const option = find(newOptions, { value: term.value })
          if (!option) {
            term.count = 0
          } else {
            assign(term, option)
          }
          return term
        })

        // Add new options
        each(newOptions, (option) => {
          const term = find(this.terms, {value: option.value})
          if (!term) {
            this.terms.push(option)
          }
        })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-terms.vue